(function () {

  function normalizeSku(value) {
    return String(value || '')
      .trim()
      .toUpperCase();
  }


  function parseOrderList(value) {

    const lines = String(value || '')
      .split(/\r?\n/)
      .map(line => line.trim())
      .filter(Boolean);

    const parsed = [];
    const errors = [];

    lines.forEach(function (line, index) {

      const parts = line
        .replace(/[,;\t]+/g, ' ')
        .split(/\s+/)
        .filter(Boolean);

      if (!parts.length) return;

      const sku = normalizeSku(parts[0]);

      let quantity = 1;

      if (parts.length > 1) {
        quantity = parseInt(parts[1], 10);
      }

      if (!sku) {
        errors.push({
          line: index + 1,
          text: line
        });

        return;
      }

      if (!Number.isInteger(quantity) || quantity < 1) {
        errors.push({
          line: index + 1,
          text: line
        });

        return;
      }

      parsed.push({
        sku: sku,
        quantity: quantity
      });

    });


    const merged = new Map();

    parsed.forEach(function (item) {

      if (merged.has(item.sku)) {
        merged.get(item.sku).quantity += item.quantity;
      } else {
        merged.set(item.sku, {
          sku: item.sku,
          quantity: item.quantity
        });
      }

    });


    return {
      items: Array.from(merged.values()),
      errors: errors
    };

  }


  async function findVariantBySku(sku) {

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';


    const query = encodeURIComponent(sku);

    const url =
      root +
      'search/suggest.json' +
      '?q=' + query +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=show' +
      '&resources[options][fields]=' +
      encodeURIComponent(
        'variants.sku,variants.barcode,title'
      );


    const searchResponse = await fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    });


    if (!searchResponse.ok) {
      throw new Error('Search request failed');
    }


    const searchData = await searchResponse.json();

    const products =
      searchData &&
      searchData.resources &&
      searchData.resources.results &&
      searchData.resources.results.products
        ? searchData.resources.results.products
        : [];


    for (const product of products) {

      if (!product.url) continue;


      const productUrl = new URL(
        product.url,
        window.location.origin
      );


      const jsUrl =
        productUrl.pathname.replace(/\/$/, '') + '.js';


      const productResponse = await fetch(jsUrl, {
        headers: {
          'Accept': 'application/json'
        }
      });


      if (!productResponse.ok) continue;


      const productData = await productResponse.json();


      const variant = (productData.variants || []).find(
        function (candidate) {
          return normalizeSku(candidate.sku) === sku;
        }
      );


      if (variant) {
        return {
          id: variant.id,
          sku: sku,
          title: productData.title,
          variantTitle: variant.title,
          available: Boolean(variant.available)
        };
      }

    }


    return null;

  }


  function renderResults(container, items) {

    container.innerHTML = '';


    items.forEach(function (item) {

      const row = document.createElement('div');

      row.className = 'inv-direct-order-result';


      if (!item.found || !item.available) {
        row.classList.add('is-error');
      }


      const sku = document.createElement('div');

      sku.className =
        'inv-direct-order-result__sku';

      sku.textContent = item.sku;


      const qty = document.createElement('div');

      qty.className =
        'inv-direct-order-result__qty';

      qty.textContent =
        'Menge ' + item.quantity;


      const status = document.createElement('div');

      status.className =
        'inv-direct-order-result__status';


      if (!item.found) {
        status.textContent = 'Nicht gefunden';
      } else if (!item.available) {
        status.textContent = 'Nicht verfügbar';
      } else {
        status.textContent = 'Gefunden ✓';
      }


      row.appendChild(sku);
      row.appendChild(qty);
      row.appendChild(status);

      container.appendChild(row);

    });

  }


  function initDirectOrder(section) {

    const input =
      section.querySelector('[data-inv-order-input]');

    const checkButton =
      section.querySelector('[data-inv-order-check]');

    const cartButton =
      section.querySelector('[data-inv-order-cart]');

    const message =
      section.querySelector('[data-inv-order-message]');

    const results =
      section.querySelector('[data-inv-order-results]');

    const gotoCart =
      section.querySelector('[data-inv-order-goto-cart]');


    if (
      !input ||
      !checkButton ||
      !cartButton ||
      !message ||
      !results
    ) {
      return;
    }


    let resolvedItems = [];


    checkButton.addEventListener(
      'click',
      async function () {

        const parsed =
          parseOrderList(input.value);


        resolvedItems = [];

        results.hidden = true;
        cartButton.hidden = true;
        gotoCart.hidden = true;


        message.hidden = false;
        message.className =
          'inv-direct-order__message';


        if (!parsed.items.length) {

          message.classList.add('is-error');

          message.textContent =
            'Bitte mindestens eine Artikelnummer eingeben.';

          return;
        }


        if (parsed.errors.length) {

          message.classList.add('is-error');

          message.textContent =
            'Bitte Format prüfen: Artikelnummer und Menge, z. B. INV-WIP-P9 10.';

          return;
        }


        if (parsed.items.length > 40) {

          message.classList.add('is-error');

          message.textContent =
            'Bitte maximal 40 Artikel gleichzeitig prüfen.';

          return;
        }


        checkButton.disabled = true;

        checkButton.textContent =
          'Artikel werden geprüft…';


        message.textContent =
          'Bestellliste wird mit dem Sortiment abgeglichen.';


        try {

          const resolved =
            await Promise.all(
              parsed.items.map(
                async function (item) {

                  try {

                    const variant =
                      await findVariantBySku(item.sku);


                    if (!variant) {

                      return {
                        sku: item.sku,
                        quantity: item.quantity,
                        found: false,
                        available: false
                      };

                    }


                    return {
                      sku: item.sku,
                      quantity: item.quantity,
                      id: variant.id,
                      title: variant.title,
                      found: true,
                      available: variant.available
                    };

                  } catch (error) {

                    return {
                      sku: item.sku,
                      quantity: item.quantity,
                      found: false,
                      available: false
                    };

                  }

                }
              )
            );


          resolvedItems = resolved;


          renderResults(
            results,
            resolvedItems
          );


          results.hidden = false;


          const valid =
            resolvedItems.filter(
              item =>
                item.found &&
                item.available
            );


          const invalid =
            resolvedItems.length -
            valid.length;


          if (valid.length) {

            cartButton.hidden = false;

            message.classList.add('is-success');

            message.textContent =
              valid.length +
              ' Artikelposition(en) sind bestellbereit' +
              (
                invalid
                  ? '. ' +
                    invalid +
                    ' Position(en) bitte prüfen.'
                  : '.'
              );

          } else {

            message.classList.add('is-error');

            message.textContent =
              'Keine bestellbaren Artikel gefunden. Bitte Artikelnummern prüfen.';

          }


        } finally {

          checkButton.disabled = false;

          checkButton.textContent =
            'Liste prüfen';

        }

      }
    );


    cartButton.addEventListener(
      'click',
      async function () {

        const validItems =
          resolvedItems
            .filter(
              item =>
                item.found &&
                item.available
            )
            .map(
              item => ({
                id: item.id,
                quantity: item.quantity
              })
            );


        if (!validItems.length) return;


        const root =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';


        cartButton.disabled = true;

        cartButton.textContent =
          'Wird hinzugefügt…';


        try {

          const response =
            await fetch(
              root + 'cart/add.js',
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',
                  'Accept':
                    'application/json'
                },

                body: JSON.stringify({
                  items: validItems
                })
              }
            );


          if (!response.ok) {
            throw new Error('Cart error');
          }


          const cartResponse =
            await fetch(
              root + 'cart.js'
            );


          const cart =
            await cartResponse.json();


          let cartCount =
            document.querySelector(
              '.inv-cart-count'
            );


          if (!cartCount) {

            const cartLink =
              document.querySelector(
                '.inv-cart-link'
              );


            if (cartLink) {

              cartCount =
                document.createElement('span');

              cartCount.className =
                'inv-cart-count';

              cartLink.appendChild(
                cartCount
              );

            }

          }


          if (cartCount) {
            cartCount.textContent =
              cart.item_count;
          }


          message.hidden = false;

          message.className =
            'inv-direct-order__message is-success';

          message.textContent =
            'Bestellliste wurde dem Warenkorb hinzugefügt.';


          cartButton.hidden = true;
          gotoCart.hidden = false;


        } catch (error) {

          message.hidden = false;

          message.className =
            'inv-direct-order__message is-error';

          message.textContent =
            'Die Bestellung konnte nicht hinzugefügt werden. Bitte erneut versuchen.';


        } finally {

          cartButton.disabled = false;

          cartButton.textContent =
            'Gefundene Artikel in den Warenkorb';

        }

      }
    );

  }


  function init() {

    document
      .querySelectorAll(
        '[data-inv-direct-order]'
      )
      .forEach(initDirectOrder);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();